module.exports = __webpack_public_path__ + "img/thumb_down.f60b484a.png";